// extracted by mini-css-extract-plugin
export default {"preferenceElementWrapper":"styles_preferenceElementWrapper__l2O9B","toggle":"styles_toggle__F7MzC","title":"styles_title__X+hIn","label":"styles_label__DIaoh"};